import {
  DealerAddress,
  OrganizationAddress
} from "@common-core/coat-operational-hierarchy-appsync-model";

export const toOrganizationAddress = (
  address?: DealerAddress
): OrganizationAddress => {
  return {
    streetAddressLine1: address?.street,
    streetAddressLine2: address?.streetAddressLine2,
    city: address?.city,
    state: address?.state,
    country: address?.country,
    zip: address?.zip
  };
};
